import Head from 'next/head';
import { NextSeo } from 'next-seo';
import Career from '@cont/Careers';
import CareersPageLayout from '@layout/CareersPageLayout';
import setupInitialProps from '@utils/setupInitialProps';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const CareerLandingPage = () => {
  const title = "Careers at Unacademy – Join India's EdTech Team";
  const url = 'https://unacademy.com/careers';
  const description =
    "Explore careers at Unacademy, India's largest online learning platform. View job openings in design, engineering & product and shape education's future.";

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        url={url}
        openGraph={{ title, description, url }}
      />
      <Head>
        <title>{title}</title>
      </Head>
      <Career />
    </>
  );
};

CareerLandingPage.Layout = CareersPageLayout;

CareerLandingPage.pageInfo = {
  name: 'Unacademy Careers',
  isMWebSupported: true,
  layoutOptions: {
    hideIntercom: true,
    hideFreshbot: true,
    hideGoalSelector: true,
    disableDarkMode: true
  }
};

CareerLandingPage.getInitialProps = setupInitialProps(
  null,
  CareerLandingPage.pageInfo
);

export default CareerLandingPage;

CareerLandingPage.propTypes = {};
CareerLandingPage.Wrapper = PageReduxProvider;
